import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 20px;
  &:before {
    content: '';
    color: white;
    height: 50px;
    width: 50px;
    background: transparent;
    border-radius: 50%;
    border: 10px solid blue;
    border-color: #353d48 #0066ff #353d48 #353d48;
    animation: ${rotateAnimation} 0.6s infinite ease-in-out;
    box-shadow: 0px 0px 77px -2px rgba(0, 102, 255, 0.6);
  }
`;

export default Spinner;
